import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
/**
 * Home Buy Component
 */
let HomeSellComponent = class HomeSellComponent {
    constructor() { }
};
HomeSellComponent = __decorate([
    Component({
        selector: 'ecd-home',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./home.component.html")).default
    })
], HomeSellComponent);
export { HomeSellComponent };
